import { Link } from "react-router-dom";

export default function Footer({ t }) {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="bg-[#1a2421] text-[#f9f6f0] pt-24 pb-12"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <p className="font-serif text-5xl md:text-6xl tracking-tight leading-none">
              Eliora
              <br />
              <span className="italic text-[#bc6c25]">Longevity</span>
            </p>
            <p className="mt-6 text-base text-[#f9f6f0]/70 max-w-md">
              {t.footer.tagline}
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.22em] text-[#bc6c25]">Explora</p>
            <ul className="mt-4 space-y-2 text-sm text-[#f9f6f0]/75">
              <li><Link to="/immunocal" className="hover:text-[#bc6c25]">Immunocal</Link></li>
              <li><Link to="/immunocal-precio" className="hover:text-[#bc6c25]">Immunocal precio</Link></li>
              <li><Link to="/glutation" className="hover:text-[#bc6c25]">Glutatión</Link></li>
              <li><Link to="/sistema-inmunologico" className="hover:text-[#bc6c25]">Sistema inmunológico</Link></li>
              <li><Link to="/blog" className="hover:text-[#bc6c25]">Blog</Link></li>
              <li><Link to="/sobre-sarai" className="hover:text-[#bc6c25]">Nuestra Fundadora</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-[0.22em] text-[#bc6c25]">
              Disclaimer
            </p>
            <p className="mt-4 text-sm leading-relaxed text-[#f9f6f0]/60 max-w-md">
              {t.footer.disclaimer}
            </p>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs uppercase tracking-[0.18em] text-[#f9f6f0]/45">
          <p>© {year} Eliora Longevity. {t.footer.rights}</p>
          <p>Immunotec® is a registered trademark of Immunotec Inc.</p>
        </div>
      </div>
    </footer>
  );
}
